import React from 'react'
import fetch from 'isomorphic-unfetch'
import { useNavigate } from '@reach/router'
import { useTransifex } from '@utils/transifex'

import { Flex } from '@components/Base'

export const Form = ({
    formName,
    onSubmit,
    redirectTo,
    setError,
    ...props
}) => {
    const tx = useTransifex()
    const navigate = useNavigate()

    const submitForm = async ({
        your_company_website_url: honeypot,
        ...data
    }) => {
        setError(false)

        if (honeypot === '') {
            await fetch('/api/submitForm', {
                method: 'POST',
                body: JSON.stringify({
                    form: formName,
                    lang: tx.language,
                    data: data,
                }),
            }).then(res => {
                if (res.ok) {
                    navigate(redirectTo, { replace: true })
                } else {
                    setError(true)
                }
            })
        } else {
            // Honeypot fail
            navigate(redirectTo, { replace: true })
        }
    }

    return (
        <Flex
            as="form"
            flexWrap="wrap"
            mx={-4}
            pt={2}
            onSubmit={onSubmit(submitForm)}
            {...props}
        />
    )
}

export default Form
